import { render } from "./About.vue?vue&type=template&id=269b67d9"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"
script.render = render

export default script